import type { AxiosInstance } from 'axios';
import { contactRuleSettingsApiPaths } from './paths';
import type {
  ContactRuleSettingsResponse,
  SendingCompanySettings,
  UpdateContactRuleSettingsPayload
} from './types';

export type {
  ContactRuleBand,
  ContactRuleBandSettings,
  ContactRuleSettingsBody,
  ContactRuleSettingsResponse,
  SendingCompanySettings,
  UpdateContactRuleSettingsPayload
} from './types';
export { ALL_SUB_BRANDS_COMPANY, CONTACT_RULE_BANDS } from './types';
export { contactRuleSettingsQueryKeys } from './query-keys';
export { useContactRuleSettingsQuery } from './use-contact-rule-settings-queries';
export { useUpdateContactRuleSettingsMutation } from './use-contact-rule-settings-mutations';

/**
 * Caps and gaps per sending company. Lives in the insights service, called
 * directly from the browser with the user's CRM token (see
 * `@/api-client/insights`); insights resolves the user, firm and scopes from
 * the CRM. Saves are optimistic-locked: the row's `version` goes in `If-Match`,
 * 409 means someone saved first, 428 means the header was missing.
 */
export class ApiContactRuleSettings {
  constructor(private readonly client: AxiosInstance) {}

  async get(): Promise<ContactRuleSettingsResponse> {
    const res = await this.client.get<ContactRuleSettingsResponse>(
      contactRuleSettingsApiPaths.settings
    );
    return res.data;
  }

  async update(
    companyUuid: string,
    version: number,
    payload: UpdateContactRuleSettingsPayload
  ): Promise<SendingCompanySettings> {
    const res = await this.client.put<SendingCompanySettings>(
      contactRuleSettingsApiPaths.company(companyUuid),
      payload,
      { headers: { 'If-Match': String(version) } }
    );
    return res.data;
  }
}
